import React, {
  useRef, useEffect, useCallback,
} from 'react';
import { FormHandles } from '@unform/core';
import { Form as UForm } from '@unform/web';
import * as Yup from 'yup';
import { useHistory, useParams } from 'react-router-dom';
import getValidationError from '../../../../../utils/getValidationsErros';

/** hooks */
import { useHttp } from '../../../../../hooks/http';
import { useToast } from '../../../../../hooks/toast';

/** componentes */
import { Grid } from '../../../../../components/Flex';
import {
  WrapperLabel, Input, Button,
} from '../../../../../components/Forms';
import { Container } from './styles';

const Save: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const { addToast } = useToast();
  const history = useHistory();
  const { id } = useParams<{ id?: string}>();
  const {
    httpGet, httpPost, httpPut, loading,
  } = useHttp();

  useEffect(() => {
    (async () => {
      if (id && id !== 'new') {
        const { status, data } = await httpGet(`/register-types/${id}`);
        if (status === 200) {
          formRef.current?.setData(data);
        }
      }
    })();
  }, [httpGet, id]);

  const handleSubmit = useCallback(async (payload: any) => {
    try {
      formRef.current?.setErrors({});

      const schema = Yup.object().shape({
        name: Yup.string().required('Nome é obrigatório'),
      });

      await schema.validate(payload, { abortEarly: false });

      if (id && id !== 'new') {
        await httpPut(`/register-types/${id}`, payload);
        addToast({ title: 'Editado com sucesso!' });
      } else {
        const { status, data } = await httpPost('register-types', payload);
        if (status === 200) {
          addToast({ title: 'Salvo com sucesso!' });
          history.push(`/settings/register-types/${data.id}`);
        }
      }
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const erros = getValidationError(err);
      formRef.current?.setErrors(erros);
      }
    }
  }, [id, httpPut, addToast, httpPost, history]);

  return (
    <Container>
      <h1>{id && id !== 'new' ? 'Editar' : 'Novo'} Tipo de registro</h1>
      <UForm ref={formRef} onSubmit={handleSubmit}>
        <Grid container spacing={1}>
          <WrapperLabel label="Nome" xs={12}>
            <Input name="name" />
          </WrapperLabel>
        </Grid>
        <Grid container justify="flex-end">
          <Grid item xs={12} md={2}>
            <Button type="submit" isLoading={loading}>
              Salvar
            </Button>
          </Grid>
        </Grid>
      </UForm>
    </Container>
  );
};

export default Save;
